import { logger } from '@gem/modules/logger';

import { SecretChatAccessRequestStatus } from 'APP/model/e2ee/e2eeModel.types';
import { e2eeModel } from 'APP/model/model';
import Entities from 'STORE';
import { SecretGroup } from 'STORE/Groups/SecretGroup/SecretGroup';

import { acceptSecretGroupAccessRequestStatus } from './acceptSecretGroupAccessRequestStatus';

interface IApproveSecretGroupRequestAccessParams {
  deviceId: string;
  userId: string;
  groupId: string;
}

export const approveSecretGroupRequestAccess = async (
  params: IApproveSecretGroupRequestAccessParams
): Promise<{ success: boolean; showError?: boolean }> => {
  try {
    const secretGroup = Entities.GroupsStore.getGroupById(params.groupId);

    if (!secretGroup || !(secretGroup instanceof SecretGroup)) {
      return { success: false };
    }

    const response = await e2eeModel.consumeKeyPackagesByDeviceIdAndUserId(
      params.deviceId,
      params.userId,
      1
    );

    if (!response.keyPackages.length) {
      return { success: false, showError: false };
    }

    const result = await acceptSecretGroupAccessRequestStatus({
      groupId: params.groupId,
      deviceId: params.deviceId,
      userId: params.userId,
      keyPackage: response.keyPackages[0],
    });

    if (result.error) {
      throw new Error(result.error);
    }

    secretGroup.setDevicesRequestStatus(params.deviceId, SecretChatAccessRequestStatus.Accepted);

    if (secretGroup.chatAccessRequestsCount !== 0) {
      secretGroup.setChatAccessRequestsCount(secretGroup.chatAccessRequestsCount - 1);
    }

    return { success: true };
  } catch (e) {
    logger.get('Tasks').error('e2ee.approveSecretGroupRequestAccess', e);
    return { success: false, showError: true };
  }
};
